import React, { Component } from "react";
import { Field, Formik, Form } from "formik";
import { ClipLoader } from "react-spinners";
import swal from "sweetalert";
import Select from "react-select";
import DatePicker from "react-datepicker";

import { utils } from "~/utils";
import { service as dashboard_service } from "../redux";

class NonSodeDashboardReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoadig: false,
            input_circles_value: ""
        };
    }

    render() {
        return (
            <div>
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <Formik onSubmit={values => this.handleSubmit(values)}>
                            {formik => {
                                const { values, setFieldValue } = formik;
                                return (
                                    <Form>
                                        <div className="row">
                                            <div className="form-group col-4">
                                                <label>Filter by</label>
                                                <Field
                                                    name="option"
                                                    component={Select}
                                                    value={values.option}
                                                    isClearable
                                                    cacheOptions
                                                    defaultOptions
                                                    options={[
                                                        { value: "scratchpo__created_at", label: "PO CREATION DATE" },
                                                        { value: "ssot_runs__project_request_delivery_date", label: "DELIVERY DATE" },
                                                        { value: "oet__customer_purchase_order__non_sode__created_at", label: "OET APPROVAL REQUEST DATE" },
                                                        { value: "oet__customer_purchase_order__non_sode__approval_date", label: "OET APPROVAL DATE" },
                                                    ]}
                                                    onChange={val => setFieldValue("option", val, false)}
                                                />
                                            </div>
                                            <div className="form-group col-4">
                                                <label>Start date</label>
                                                <Field
                                                    className="form-control"
                                                    name="start_date"
                                                    autoComplete="off"
                                                    component={DatePicker}
                                                    dateFormat="dd/MM/yyyy"
                                                    selected={values.start_date}
                                                    isClearable
                                                    cacheOptions
                                                    defaultOptions
                                                    onChange={val => setFieldValue("start_date", val, false)}
                                                />
                                            </div>
                                            <div className="form-group col-4">
                                                <label>End date</label>
                                                <Field
                                                    className="form-control"
                                                    name="end_date"
                                                    autoComplete="off"
                                                    component={DatePicker}
                                                    dateFormat="dd/MM/yyyy"
                                                    selected={values.end_date}
                                                    isClearable
                                                    cacheOptions
                                                    defaultOptions
                                                    onChange={val => setFieldValue("end_date", val, false)}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="form-group col-6">
                                                <label>PO number</label>
                                                <Field
                                                    name="po_number"
                                                    className="form-control"
                                                    />
                                            </div>
                                            <div className="form-group col-6">
                                                <label>Run Status</label>
                                                <Field
                                                    name="run_status"
                                                    component={Select}
                                                    value={values.run_status}
                                                    isClearable
                                                    cacheOptions
                                                    defaultOptions
                                                    options={[
                                                        { value: "project", label: "PROJECT" },
                                                        { value: "tcc", label: "TCC" },
                                                        { value: "fandc", label: "F&C" },
                                                        { value: "cpm", label: "CPM" },
                                                        { value: "omc", label: "OMC" },
                                                        { value: "closed", label: "Closed" },
                                                        { value: "cancelled", label: "Cancelled" },
                                                    ]}
                                                    onChange={val => setFieldValue("run_status", val, false)}
                                                />
                                            </div>
                                            <div className="form-group col-6">
                                                <label>Customer team</label>
                                                <Field
                                                    name="customers_team_name"
                                                    component={Select}
                                                    value={values.customers_team_name}
                                                    isClearable
                                                    cacheOptions
                                                    defaultOptions
                                                    options={[
                                                        { value: "bharti_infratel_limited", label: "Bharti infratel limited" },
                                                        { value: "Indian_Railways", label: "Indian Railways" },
                                                        { value: "Alstom", label: "ALSTOM" },
                                                        { value: "MTNL", label: "MTNL" },
                                                        { value: "BSNL", label: "BSNL" },
                                                        { value: "vodafone_idea_limited_india", label: "Vodafone idea india" },
                                                        { value: "bharti_airtel_india_parser", label: "Bharti Airtel India" },
                                                        { value: "reliance_jio_parser", label: "Reliance Jio" },
                                                    ]}
                                                    onChange={val => setFieldValue("customers_team_name", val, false)}
                                                />
                                            </div>
                                            <div className="form-group col-6">
                                                <label>Circle</label>
                                                <Field
                                                    name="circle"
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                        <button type="submit" className="btn btn-success">
                                            Download
                                        </button>
                                        {this.state.isLoadig && (
                                            <div className="float-right">
                                                <ClipLoader />
                                            </div>
                                        )}
                                    </Form>
                                );
                            }}
                        </Formik>
                    </div>
                </div>
            </div>
        );
    }

    handleSubmit = values => {
        let request = utils.clearObjectNulls({
            option: values && values.option ? values.option.value : null,
            run_status: values && values.run_status ? values.run_status.value : null,
            customers_team_name: values && values.customers_team_name ? values.customers_team_name.value : null,
            
        });
        request.start_date = values.start_date
        request.end_date = values.end_date
        request.po_number = values.po_number;
        request.circle = values.circle;

        const errorMessage = () => {
            swal({
                title: "Warning ...",
                text: "An error has occurred while trying to download the report",
                icon: "warning",
                button: true
            });
        };

        const errorRequiredMessage = () => {
            swal({
                title: "Warning ...",
                text: "Filter by is a required field",
                icon: "warning",
                button: true
            });
        };

        if (!request.option){
            errorRequiredMessage();
        } else {

            this.setState({ isLoadig: true });
            dashboard_service.getNonSodeDashboardReport(request)
                .then(response => {
                    this.setState({isLoadig: false})
                    swal({
                        title: "Success",
                        text: response.detail,
                        icon: "success",
                        button: true
                    });
                })
                .catch(_ => {
                    this.setState({isLoadig: false});
                    errorMessage();
                });

        }
    };
}

export default NonSodeDashboardReport;
